/* eslint-disable import/prefer-default-export */
import isEmptyUtil from '@utils/isEmpty';
import {
  EXAMS,
  IIT_JEE_POINTS,
  POINTS,
  BENEFITS,
  IIT_JEE_BENEFITS,
  FAQ_YOTUH
} from './constant';

export const isRequired = (errorMessage) => (value) => {
  if (isEmptyUtil(value)) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};

export const scoreWithinRange = (errorMessage, min, max) => (value) => {
  if (value < min || value > max) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};

export const isFutureDate = (errorMessage) => (value) => {
  if (value > new Date()) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};

// this function will match the input string length
// input: error message string and length to be match
// return: error object in case of length does not match
export const isLengthError = (errorMessage, length) => (value) => {
  if (value.toString().length !== length) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};
export const isNeetUGApplicationNumber = (errorMessage, examUID) => (value) => {
  if (!value.toString().startsWith('2404') && examUID === 'NTAVDLBKV4') {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};

export const isFloat = (errorMessage) => (value) => {
  if (Number(value) === value && value % 1 !== 0) {
    return {
      error: true,
      message: errorMessage
    };
  }
  return {};
};

export const NEET_UG_UID = 'YOTUH';
export const IIT_JEE_UID = 'TMUVD';

export const NEET_UG_EXAM_UID = 'NTAVDLBKV4';
export const IIT_JEE_MAIN_EXAM_UID = 'V3O412F0LO';
export const AITS_EXAM_UID = 'AITS';
export const UNACDEMY_EXAM_UID = 'UNACADEMY';

const rankPredictorAvailable = [NEET_UG_EXAM_UID, IIT_JEE_MAIN_EXAM_UID];

const currentYear = new Date().getFullYear();

export const getMetaInfo = (goalUID) => {
  if (goalUID === IIT_JEE_UID) {
    return {
      title: `JEE Main Rank Predictor ${currentYear}: Predict your JEE Main Rank`,
      description: `JEE Main Rank Predictor ${currentYear}: It enables candidates to predict their rank based on the score they expect in the JEE Mains ${currentYear}`
    };
  }

  if (goalUID === NEET_UG_UID) {
    return {
      title: `NEET UG Rank Predictor ${currentYear}: Predict your NEET UG Rank`,
      description: `NEET UG Rank Predictor ${currentYear}: It enables candidates to predict their rank based on the score they expect in the NEET UG ${currentYear}`
    };
  }

  return {
    title: 'Rank Predictor',
    description: 'Get estimated rank based on your expected marks'
  };
};

export const getExamUIDByGoalUID = (goalUID) => {
  if (goalUID === NEET_UG_UID) {
    return NEET_UG_EXAM_UID;
  }

  return IIT_JEE_MAIN_EXAM_UID;
};

export const isRankPredictorAvailable = (examUID) =>
  rankPredictorAvailable.includes(examUID);

export const getExamInfo = (examUID, exam_type) => {
  const eId = exam_type === AITS_EXAM_UID ? AITS_EXAM_UID : examUID;
  return EXAMS[eId] || {};
};

export const getIsIITJeeRankPredictor = (examUID) =>
  examUID === IIT_JEE_MAIN_EXAM_UID;

export const getPredictorConfig = (examUID, exam_type) => {
  const examInfo = getExamInfo(examUID, exam_type);
  const config = {
    title: `${examInfo.name} Rank Predictor 2024`,
    points: POINTS,
    benefits: BENEFITS
  };
  if (examUID === IIT_JEE_MAIN_EXAM_UID) {
    config.title = 'JEE Advanced 2024 Rank Predictor';
    config.points = IIT_JEE_POINTS;
    config.benefits = IIT_JEE_BENEFITS;
  } else if (examUID === AITS_EXAM_UID) {
    config.points = IIT_JEE_POINTS;
    config.benefits = IIT_JEE_BENEFITS;
  }

  return config;
};

export const staticPagePathParams = [
  { goalSlug: 'neet-rank-predictor', goalUID: 'YOTUH' },
  {
    goalSlug: 'jee-main-and-advanced-preparation',
    goalUID: 'TMUVD'
  }
];

export const getFaqs = (goalUID) => {
  if (goalUID === NEET_UG_UID) {
    return FAQ_YOTUH;
  }
  return [];
};
